/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Contract_Start_DateInputs */

const en_clients_field_contract_start_date = /** @type {(inputs: Clients_Field_Contract_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date Start`)
};

const pt_br2_clients_field_contract_start_date = /** @type {(inputs: Clients_Field_Contract_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de Início`)
};

/**
* | output |
* | --- |
* | "Date Start" |
*
* @param {Clients_Field_Contract_Start_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_contract_start_date = /** @type {((inputs?: Clients_Field_Contract_Start_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Contract_Start_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_contract_start_date(inputs)
	return pt_br2_clients_field_contract_start_date(inputs)
});